import { render, staticRenderFns } from "./CommercialForSale.vue?vue&type=template&id=37d53376&scoped=true&"
import script from "./CommercialForSale.vue?vue&type=script&lang=ts&"
export * from "./CommercialForSale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d53376",
  null
  
)

export default component.exports